var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDevice = function SvgDevice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#64748B",
    d: "M14 1.667H5.175a3.5 3.5 0 0 0-3.5 3.492v5.308a3.49 3.49 0 0 0 3.492 3.492h3c.458 0 .833.375.833.833v.683a.836.836 0 0 1-.833.834H6.292a.594.594 0 0 0-.592.591c0 .325.267.592.592.592H12.9a.594.594 0 0 0 .592-.592.594.594 0 0 0-.592-.591h-1.875a.836.836 0 0 1-.833-.834v-.683c0-.458.375-.833.833-.833H14a3.49 3.49 0 0 0 3.492-3.492V5.159A3.496 3.496 0 0 0 14 1.667",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#64748B",
    d: "M16.367 7.917h-4.409c-1.441 0-1.966.525-1.966 1.983v6.442c0 1.467.516 1.983 1.966 1.983h4.409c1.441 0 1.966-.525 1.966-1.983V9.9c0-1.466-.516-1.983-1.966-1.983m-2.2 9.017a.914.914 0 0 1-.917-.917c0-.508.408-.917.917-.917.508 0 .916.409.916.917a.914.914 0 0 1-.916.917"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#64748B",
    d: "M15.083 16.016a.914.914 0 0 1-.916.917.914.914 0 0 1-.917-.917c0-.508.408-.916.917-.916a.92.92 0 0 1 .916.916",
    opacity: 0.4
  })));
};
export default SvgDevice;